import {Component, ElementRef} from '@angular/core';
import {Vehicle} from '@ox/typings';
import {DealerMapService} from '../../../../dealer-map/dealer-map.service';
import {DealerInfoWithMapWebuComponent} from '../../dealer-info-webu.component';
import {AppConfigService, AutoDestroy} from '@ox/utils';
import {Subject, takeUntil, tap} from 'rxjs';
import {Store} from '@ngrx/store';
import {selectActiveVehicle} from '@ox/data';
import {isEqual} from 'lodash';

@Component({
  selector: 'webu-dealer-info',
  templateUrl: './kr-dealer-info-webu.component.html'
})
export class KRDealerInfoWithMapWebuComponent extends DealerInfoWithMapWebuComponent {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  scheduleServiceUrl: string;
  activeVehicle: Vehicle;
  activeVehicle$ = this.store.select(selectActiveVehicle).pipe(takeUntil(this.destroy$), tap((vehicle) => {
    if (vehicle && !isEqual(this.activeVehicle, vehicle)) {
      this.activeVehicle = vehicle;
    }
  }));
  vehicleMake: string;

  constructor(
    element: ElementRef,
    dealerMapService: DealerMapService,
    private store: Store,
    private appConfig: AppConfigService
  ) {
    super(
      element,
      dealerMapService);
    this.activeVehicle$.subscribe();
    this.vehicleMake = (this.activeVehicle) ? this.activeVehicle.make.toLowerCase() : this.appConfig.bml.brand.toLowerCase();
  }
}
